import axios from 'axios';
import {
  CaseZoningPlanComplianceModel,
  CaseZoningPlanModel,
} from 'app/edozvola/cases/case-zoning-plan-compliance/model/case-zoning-plan-compliance.model';

export const saveCaseZoningPlan = async (idCase: string, caseZoningPlan: CaseZoningPlanModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/zoning-plans`, caseZoningPlan)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCaseZoningPlans = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/cases/${idCase}/zoning-plans?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteCaseZoningPlan = async (idCaseZoningPlanMap: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/cases/null/zoning-plans/${idCaseZoningPlanMap}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveZoningPlanCompliance = async (idCase: string, zoningPlanCompliance: CaseZoningPlanComplianceModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/zoning-plan-compliance`, zoningPlanCompliance)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getZoningPlanCompliance = async (idCase: string): Promise<CaseZoningPlanComplianceModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${idCase}/zoning-plan-compliance`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchIspuZoningPlan = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/fetch-ispu-zoning-plan`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
